import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
	return (
		<header className="header py-3">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-auto">
						<Link to="/" className="text-decoration-none">
							<img src="/assets/logo/thankwich-logo.png" alt="Thankwich Logo" className="logo heartbeat" style={{ height: '100px', width: 'auto' }} />
						</Link>
					</div>
				</div>
			</div>
		</header>
	);
}

export default Header;
